import React from "react";
import Head from "next/head";

export const Assets = () => (
  <Head>
    <link
      rel="icon"
      href="https://s.catch.com.au/static/catch/images/icons/favicon-2c7745d709.png"
    />
    <link
      rel="preload"
      href="https://s.catch.com.au/static/catch/images/logo-condensed-acc008b165.svg"
      as="svg"
      media="(max-width: 375px)"
    />
  </Head>
);
